import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useRide } from '../contexts/RideContext';
import { Truck, DollarSign, CheckCircle, AlertCircle, ShieldCheck } from 'lucide-react';
import { Agent } from '@ouagaliv/shared';

export default function Home() {
  const { user } = useAuth();
  const agentUser = user as Agent | null;
  const { availableRides, isLoading } = useRide();

  const stats = [
    { label: 'Courses aujourd\'hui', value: '12', icon: Truck, color: 'text-primary' },
    { label: 'Gains du jour', value: '15,400 FCFA', icon: DollarSign, color: 'text-secondary' },
    { label: 'Taux d\'acceptation', value: '92%', icon: CheckCircle, color: 'text-green-600' },
    { label: 'Note', value: '4.8', icon: AlertCircle, color: 'text-amber-600' },
  ];

  const isActive = agentUser?.status === 'active';

  return (
    <div className="page-transition">
      <section className="container py-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-text">Bonjour, {agentUser?.fullName.split(' ')[0]} !</h1>
            <p className="text-text-secondary text-sm">{agentUser?.vehicleType} • {agentUser?.rating}★ • {agentUser?.totalRides} courses</p>
          </div>
        </div>

        {!isActive && (
          <Link to="/onboarding" className="card mb-6 flex items-center gap-3" style={{ textDecoration: 'none', borderColor: '#d97706' }}>
            <div className="w-12 h-12 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center flex-shrink-0">
              <ShieldCheck size={24} />
            </div>
            <div>
              <p className="font-semibold text-text">Activez votre compte</p>
              <p className="text-sm text-text-secondary">Documents et formation requis avant de recevoir des courses</p>
            </div>
          </Link>
        )}

        <div className="grid grid-cols-2 gap-3 mb-6">
          {stats.map((stat, i) => (
            <Link key={i} to={i === 1 ? '/earnings' : '/available'} className="card">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <stat.icon size={24} className={stat.color} />
                </div>
                <div>
                  <p className="text-xs text-text-secondary">{stat.label}</p>
                  <p className="font-bold text-text">{stat.value}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <Link to="/available" className="btn btn-primary btn-full mb-6">
          Voir les courses disponibles <Truck size={18} />
        </Link>

        <h2 className="text-lg font-semibold text-text mb-3">Courses à proximité</h2>
        {isLoading ? (
          <div className="card">Chargement...</div>
        ) : availableRides.length === 0 ? (
          <div className="card text-center py-8">
            <Truck size={48} className="mx-auto text-text-secondary mb-3" />
            <p className="text-text-secondary">Aucune course disponible pour le moment</p>
            <p className="text-xs text-text-secondary mt-1">Activez votre disponibilité et attendez une notification</p>
          </div>
        ) : (
          <div className="space-y-3">
            {availableRides.slice(0, 3).map(ride => (
              <Link key={ride.id} to={`/ride/${ride.id}`} className="ride-card" style={{textDecoration: 'none'}}>
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary">
                      <Truck size={20} />
                    </div>
                    <div>
                      <p className="font-medium text-text">{ride.type}</p>
                      <p className="text-sm text-text-secondary">{ride.pickupAddress} → {ride.dropoffAddress}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="font-bold text-text">{ride.priceFcfa.toLocaleString()} FCFA</p>
                    <p className="text-xs text-text-secondary">{ride.distanceKm?.toFixed(1)} km</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}